import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';

const MaterialTranspotationIcon = (props) => {
  return <EmojiTransportationIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialTranspotationIcon;
